// src/components/NotificationBell.jsx
// Chuông thông báo hiển thị trên header dashboard

import { useState, useRef, useEffect } from "react";
import { formatDistanceToNow } from "date-fns";
import { vi } from "date-fns/locale";
import { useNotifications } from "../hooks/useNotifications";
import "../styles/notification.css";

const TYPE_ICON = {
  deadline_reminder: "⏰",
  task_assigned:     "📋",
  task_completed:    "✅",
};

export default function NotificationBell() {
  const [open, setOpen] = useState(false);
  const { notifications, loading, unreadCount, markAllRead, markRead } =
    useNotifications();
  const panelRef = useRef(null);

  // Đóng panel khi click ra ngoài
  useEffect(() => {
    const handler = (e) => {
      if (panelRef.current && !panelRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const handleOpen = () => {
    setOpen((v) => !v);
  };

  const handleMarkRead = async (notif) => {
    if (!notif.isRead) await markRead(notif.id);
  };

  return (
    <div className="notif-wrapper" ref={panelRef}>
      {/* Bell button */}
      <button className="notif-bell" onClick={handleOpen} title="Thông báo">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/>
          <path d="M13.73 21a2 2 0 0 1-3.46 0"/>
        </svg>
        {unreadCount > 0 && (
          <span className="notif-badge">
            {unreadCount > 9 ? "9+" : unreadCount}
          </span>
        )}
      </button>

      {/* Dropdown panel */}
      {open && (
        <div className="notif-panel">
          <div className="notif-panel-header">
            <span className="notif-panel-title">Thông báo</span>
            {unreadCount > 0 && (
              <button className="notif-mark-all" onClick={markAllRead}>
                Đọc tất cả
              </button>
            )}
          </div>

          <div className="notif-list">
            {loading ? (
              <div className="notif-empty">Đang tải...</div>
            ) : notifications.length === 0 ? (
              <div className="notif-empty">
                <span>🔕</span>
                <p>Chưa có thông báo nào</p>
              </div>
            ) : (
              notifications.map((notif) => (
                <div
                  key={notif.id}
                  className={`notif-item ${!notif.isRead ? "unread" : ""}`}
                  onClick={() => handleMarkRead(notif)}
                >
                  <span className="notif-icon">
                    {TYPE_ICON[notif.type] || "🔔"}
                  </span>
                  <div className="notif-content">
                    <p className="notif-message">{notif.message}</p>
                    <span className="notif-time">
                      {notif.sentAt?.toDate
                        ? formatDistanceToNow(notif.sentAt.toDate(), {
                            addSuffix: true,
                            locale: vi,
                          })
                        : "vừa xong"}
                    </span>
                  </div>
                  {!notif.isRead && <span className="notif-dot" />}
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
}
